import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { R290 } from '@/components/UI/svg/Wave2';

export default function L() {
    const { useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');

    useEffect(() => {
        const offset = document.body.clientWidth * 0.1574;
        AniContainer.create({
            syncFromTo: [['.wave2-detail-L .viewport-wrapper .R290', { y: offset }, { y: 0 }]],
            triggerElement: '.wave2-detail-L .viewport-wrapper',
            triggerHook: 1,
            offset: '50%',
            duration: '45%',
        });
        AniContainer.create({
            syncFromTo: [['.wave2-detail-L .viewport-wrapper .title', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-L .viewport-wrapper .text-wrapper',
            triggerHook: 1,
            offset: '10%',
            duration: '10%',
        });
        AniContainer.create({
            syncFromTo: [['.wave2-detail-L .viewport-wrapper .desc', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-L .viewport-wrapper .text-wrapper',
            triggerHook: 1,
            offset: '20%',
            duration: '10%',
        });
    }, []);

    return (
        <div className={`wave2-detail-L ${css.wave2DetailL}`}>
            <div className="viewport-wrapper">
                <p className="R290">
                    <R290 />
                </p>
                <div className="img-wrapper">
                    <NextImage
                        webpSrc={require('@publicLocal/wave2/detail/pc/section_l.webp')}
                        src={require('@publicLocal/wave2/detail/pc/section_l.png')}
                        alt={t('detail.sectionL_title')}
                        aria-label={t('detail.sectionL_title')}
                    />
                </div>
                <div className="text-wrapper">
                    <p className="title">{t('detail.sectionL_title')}</p>
                    <p className="desc">{t('detail.sectionL_desc')}</p>
                </div>
            </div>
        </div>
    );
}
